import WhyOneMindFrame from "@/components/whyOneMind";
import { WHY_ONEMIND_CONSTANTS } from "./constants";

const UseCases = () => {
  return <WhyOneMindFrame {...WHY_ONEMIND_CONSTANTS} />;
};

export default UseCases;
